import { GetTokenSilentlyOptions } from '@auth0/auth0-angular';
import { environment } from '@env/environment';

const noCache: GetTokenSilentlyOptions = {
  cacheMode: 'off',
};

// Whenever we're doing something potentially sensitive, we need to check if we still have access. Turn Cache mode off.
const noCacheRoutes = ['/api/admin/*'].map(route => {
  return {
    uri: environment.apiUrl + route,
    tokenOptions: noCache,
  };
});

export const authConfig = {
  domain: environment.auth0Domain,
  clientId: environment.auth0ClientId,
  authorizationParams: {
    redirect_uri: environment.auth0CallbackUrl,
    audience: environment.auth0Audience,
    scope: 'openid offline_access',
  },
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
  httpInterceptor: {
    allowedList: [
      ...noCacheRoutes,
      // took admin out of no cache routes because it was causing issues with the admin page.
      // This was caused by a change I made recently (prior to 12/18/25) to the authentication system, maybe login service or something else?
      // Not sure but its bonkers. need to fix.
      // environment.apiUrl + '/api/admin/*',
      environment.apiUrl + '/api/general/*',
      environment.apiUrl + '/api/agency/*',
      environment.apiUrl + '/api/Agency/*',
      environment.apiUrl + '/api/vendor/*',
      {
        uri: environment.apiUrl + '/api/Report/GetPublicReportTable',
        allowAnonymous: true,
      },
      environment.apiUrl + '/api/Report/*',
      environment.apiUrl + '/api/project/*',
      environment.apiUrl + '/api/qbat/*',
      // environment.apiUrl + '/api/Opportunity/*',
      {
        uri: environment.apiUrl + '/api/Opportunity/*',
        allowAnonymous: true,
      },
      environment.apiUrl + '/api/Shared/*',
      environment.apiUrl + '/api/Project/*',
      environment.apiUrl + '/api/UserRoleManagement/*',
      environment.apiUrl + '/api/Settings/*',
    ],
  },
};
